import { render, staticRenderFns } from "./infoTable.vue?vue&type=template&id=03d83c82&scoped=true"
import script from "./infoTable.vue?vue&type=script&lang=js"
export * from "./infoTable.vue?vue&type=script&lang=js"
import style0 from "./infoTable.vue?vue&type=style&index=0&id=03d83c82&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03d83c82",
  null
  
)

export default component.exports